/*
  Модуль попап окна
*/
import $ from 'jquery';

$.fn.popup = function(options) {
  function init($popup) {
    var $close = $('.js_popup_close', $popup);

    $(document).keyup(function(e) {
      if (e.keyCode == 27 && $popup.is(':visible')) {
        $popup.hide();
      }
    });

    $popup.on('click', function() {
      $popup.hide();
    })
    
    $close.on('click', function(e) {
      e.preventDefault();
      $popup.hide();
    })
  }

  this.each(function(index, el) {
    init($(this));
  });
}

export default function() {
  $('.js_popup').popup();
}
